<div class="modal-overlay" *ngIf="isVisible" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4 class="modal-title">Returning Patient</h4>
      <button class="close-button" (click)="closeModal()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-text">
        To schedule your appointment, please log in to your
        <app-clickable-link 
          linkText="Patient Portal." 
          linkType="portal" 
          portalUrl="https://pp-wfe-100.advancedmd.com/149583/account/logon"></app-clickable-link>
        If you've lost access to your portal or need help with your account,
        <app-clickable-link linkText="Call us." linkType="phone"></app-clickable-link>
      </p>

      <div class="button-group">
        <app-call-us-button></app-call-us-button>
        <app-patient-portal-button portalUrl="https://pp-wfe-100.advancedmd.com/149583/account/logon"></app-patient-portal-button>
      </div>
    </div>
  </div>
</div>
